import React from 'react';
import { Trans } from '@lingui/react';
import Slider from 'react-slick';
import { merge } from 'lodash-es';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function getCarouselSettings() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const defaultSettings = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    speed: 1000,
    slidesToScroll: 1,
    slidesToShow: 2,
    centerMode: true,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesPerRow: 1,
        slidesToShow: 3,
        rows: 1
      }
    }, {
      breakpoint: 767,
      settings: {
        vertical: true,
        slidesToShow: 3
      }
    }]
  };
  return merge({}, defaultSettings, overrides);
}
export function HappyCustomerSlider(_ref) {
  let {
    content,
    overrides = {},
    renderSlider = function renderSlider(settings) {
      return /*#__PURE__*/_jsx(Slider, {
        className: "happy-customer-carlead-slider-wrapper",
        ...settings,
        children: content.slides.map((slide, index) => {
          const {
            image,
            name,
            car,
            quote
          } = slide;
          return /*#__PURE__*/_jsx("div", {
            className: "happy-customer-carlead-slider__slide",
            "data-title": name.message,
            children: /*#__PURE__*/_jsxs("div", {
              className: "happy-customer-carlead-slider__slide-wrapper",
              id: content.id,
              children: [/*#__PURE__*/_jsx("div", {
                className: "happy-customer-carlead-slider__slide-image",
                children: /*#__PURE__*/_jsx("picture", {
                  children: /*#__PURE__*/_jsx("img", {
                    className: "happy-customer-carlead-slider__slide-image-icon",
                    src: image.src,
                    alt: image.alt
                  })
                })
              }), /*#__PURE__*/_jsxs("div", {
                className: "happy-customer-carlead-slider__slide-text",
                children: [/*#__PURE__*/_jsx("div", {
                  className: "happy-customer-carlead-slider__slide-text-reviewer",
                  children: /*#__PURE__*/_jsx(Trans, {
                    id: name.id
                  })
                }), /*#__PURE__*/_jsx("div", {
                  className: "happy-customer-carlead-slider__slide-text-car",
                  children: /*#__PURE__*/_jsx(Trans, {
                    id: car.id
                  })
                }), /*#__PURE__*/_jsx("div", {
                  className: "happy-customer-carlead-slider__slide-text-review",
                  children: /*#__PURE__*/_jsx("em", {
                    children: /*#__PURE__*/_jsx(Trans, {
                      id: quote.id
                    })
                  })
                })]
              })]
            })
          }, index);
        })
      });
    }
  } = _ref;
  const settings = getCarouselSettings(overrides);
  return /*#__PURE__*/_jsxs("div", {
    className: "happy-customer-carlead-slider",
    id: content.id,
    children: [/*#__PURE__*/_jsx("h2", {
      className: "happy-customer-carlead-slider__headline",
      children: /*#__PURE__*/_jsx(Trans, {
        id: content.headline.id,
        message: content.headline.message,
        components: [/*#__PURE__*/_jsx("br", {
          className: "d-none d-md-block"
        })]
      })
    }), renderSlider(settings)]
  });
}